/**
 * Subscribers Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import Swal from "sweetalert2";
import {store} from "../../store";

// States
const state = {
    subscribers: [],
    commandes: [],
    subscriber: {},
    all_commandes: []
};

// Getters
const getters = {
    subscribers: state => {
        return state.subscribers
    },

    subscriber: state => {
        return state.subscriber
    },

    commandes: state => {
        return state.commandes
    },
    all_commandes: state => {
        return state.all_commandes
    }

};

// Actions
const actions = {
    getSubscribers(context, payload) {
        function successCallback(response) {
            context.commit('getSubscribersHandler', { subscribers: response.data.souscripteurs });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Subscriber.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getSubscribersCim(context, payload) {
        function successCallback(response) {
            context.commit('getSubscribersHandler', { subscribers: response.data.souscripteurs });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Subscriber.Cim, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getSubscriber(context, payload) {
        function successCallback(response) {
            context.commit('getSubscriberHandler', { subscriber: response.data.souscripteur });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Subscriber.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getCommandes(context, payload) {
        function successCallback(response) {
            context.commit('getCommandesRestanteHandler', { commandes: response.data.commande, all_commandes: response.data.commandes });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');
        makeApiRequest(payload.args, apiModel.Commande.List, localToken, successCallback, errorCallback, payload.errorMessages);
   
      //  makeApiRequest(payload.args, apiModel.Commandes.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createSubscriber(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            if(response.data.hasOwnProperty('message')){
                Swal.fire(
                    response.data.message,
                    '',
                    'warning'
                );
            }
            if(payload.args.role == "ama"){
                localStorage.removeItem("role");
                router.push({ name: 'add-afflitation-from-ama', params: {s_id: response.data.souscripteur.user.id,  s_nom: payload.args.nom, s_prenom: payload.args.prenom, s_email: payload.args.email} });
            }else{
                router.push({ name: 'subscriber', params: { subscriber: response.data.souscripteur.slug } });
            }
           
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Subscriber.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    rappelSubscriber(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            if(response.data.hasOwnProperty('message')){
                Swal.fire(
                    response.data.message,
                    '',
                    'warning'
                );
            }
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Subscriber.Rappel, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    createPatientSouscripteur(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            if(response.data.hasOwnProperty('error')){
                Swal.fire(
                    response.data.error.commande_restant[0],
                    '',
                    'warning'
                );
               
            }

            if(router.history.current.path == "/souscripteur-dashboard"){
                window.location.reload(); 
            }else{
                router.push('/souscripteur-dashboard');
            }
           
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Subscriber.Patient, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    createOldPatientSouscripteur(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            if(response.data.hasOwnProperty('error')){
                Swal.fire(
                    response.data.error.commande_restant[0],
                    '',
                    'warning'
                );
               
            }

            if(router.history.current.path == "/souscripteur-dashboard"){
                window.location.reload(); 
            }else{
                router.push('/souscripteur-dashboard');
            }
           
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Affiliation.CreateAffiliationOldPatient, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    createPatientSouscripteurUnpaid(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            if(response.data.hasOwnProperty('error')){
                Swal.fire(
                    response.data.error.commande_restant[0],
                    '',
                    'warning'
                );
               // router.push('/paiement/'+payload.args.souscripteur_id);
            }
            router.push({ name: 'paiement', params: { identifiant: response.data.patient.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Subscriber.PatientUnpaid, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    updateSubscriber(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
           
            let souscripteur = response.data.souscripteur;
            let user = JSON.parse(localStorage.getItem('user'));
            if(user.slug === souscripteur.user.slug && user.souscripteur.slug === souscripteur.slug){
                user.souscripteur.sexe = souscripteur.sexe;
                localStorage.setItem('user',JSON.stringify(user));
                store.dispatch('findAndRemove', {name: 'SouscripteurDashboard' });
                //router.push('/add-patient-souscripteur');
                
            }else{
                store.dispatch('findAndRemove', {name: 'subscriber' });
                router.push({ name: 'subscriber', params: { subscriber: souscripteur.slug } });
            }
            
          

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Subscriber.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteSubscriber(context, payload) {
        function successCallback(response) {
            context.commit('deleteSubscriberHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Subscriber.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getSubscribersHandler(state, { subscribers }) {
        // Update subscribers state
        state.subscribers = subscribers;
    },

    getSubscriberHandler(state, { subscriber }) {
        // Update subscriber state
        state.subscriber = subscriber;
    },
    getCommandesRestanteHandler(state, { commandes, all_commandes }) {
        // Update subscriber state
        state.commandes = commandes;
        state.all_commandes = all_commandes;
    },
    deleteSubscriberHandler(state, { index, successMessage }) {
        let i = state.subscribers.findIndex(subscriber => subscriber.slug === index);

        if (~i) {
            state.subscribers.splice(i, 1);

            router.push({ name: 'subscribers' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}